const FinDocStatusObj = {
  pendingAudit: "待部門主管簽核",
  pendingMgr: "待總經理簽核",
  pendingFinance: "待財務上傳",
  done: "已完成",
  reject: "已駁回",
  cancel: "已取消",
  auditAgree: "同意",
  auditReject: "駁回",
  upload: "已上傳",
};

export default FinDocStatusObj;
